import { getWidgetSettingsByInstanceId } from 'api/widgets';

export const getChannelIdFromServer = ({ instanceId }) =>
  getWidgetSettingsByInstanceId(instanceId)
    .then(response => response.items[0])
    .then(firstWidget => _.get(firstWidget, 'settings.listId'))
    .catch(() => Promise.resolve(null));

const wrapWithCache = fn => {
  let cache = null;
  return (...args) => {
    if (cache) {
      return Promise.resolve(cache);
    }
    return fn(...args).then(response => {
      // once channel id is received it should not be changed
      cache = response;
      return cache;
    });
  };
};

export default wrapWithCache(getChannelIdFromServer);
